//_1 Importações
//_2 Mensagem de erro
//_3 Validação Yup
//_4 Ligação com a API
//_5 Styles
//_6 Formulário Login

//_1 Importações =====================================================================================
//React
import { Controller, useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import dadosAplicacao from "../../package.json";


//MUI
import { Paper, Container, TextField, Stack, Box, Button, Alert } from '@mui/material';
import KeyIcon from '@mui/icons-material/Key';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import InputAdornment from '@mui/material/InputAdornment';

//API
import api from ".././Services/api";
import { getDados } from '.././Services/globalRequests';

//Estilos
import stylesInput from '../Components/Stepps/InputStyle.module.css';
import stylesText from '../Components/Stepps/Text.module.css';
import CodigoPenal from '../Components/CódigoPenal/index';
import styleHeader from '../Components/Header/styles';
import { useMediaQuery } from 'react-responsive'
import logo1 from "../Assets/logo-pt1.png";
import logo2 from "../Assets/logo-pt2.png";

//Yup
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

//iMask
import { IMaskInput } from "react-imask";
import { LoadingButton } from '@mui/lab';
import ReactInputMask from 'react-input-mask';
import { Header } from '../Components/Header';

export const Login = ({
    endpoint = "/users/data",
    bodyParametros,
    open,
    handleClose
}) => {

    if (localStorage.getItem('AppVersion')) {
        if (localStorage.getItem('AppVersion') != dadosAplicacao.version) {
            localStorage.setItem('AppVersion', dadosAplicacao.version);
            window.location.reload(true);
        }
    } else {
        localStorage.setItem('AppVersion', dadosAplicacao.version);
        window.location.reload(true);
    }

    //_2 Mensagem de erro ================================================================================
    const [carregando, setCarregando] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [erro, setErro] = useState();
    const [erroCidadao, setErroCidadao] = useState();

    const navigate = useNavigate();

    //css
    const style = {
        icon: {
            color: 'gray',
        }
    }

    const handlePasswordVisibility = (event) => {
        event.preventDefault();
        setShowPassword(!showPassword);
    }

    async function msgError() {
        api()
            .then(res => setDados(res.data))
            .catch(err => setErro(err.response.data ? err.response.data.message : err.toString()))
            .finally(() => setCarregando(false));
    }

    //_3 Validação Yup ===================================================================================
    const schema = yup.object({
        cpf:
            yup.string()
                .required("Defina um CPF"),

        password:
            yup.string()
                .min(6, "Tamanho mínimo de 6 caracteres")
                .required("Defina uma senha*")

    }).required();

    const { handleSubmit, control, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

    //_4 Ligação com a API ================================================================================
    const [dados, setDados] = useState('');
    const [campos, setCampos] = useState(sessionStorage);

    const [ultimaChamada, setUltimaChamada] = useState(0);
    const [tempoRestante, setTempoRestante] = useState(0);
    const intervalo = 5000;

    const [contador, setContador] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setContador((prevContador) => prevContador - 1);
        }, 1000);
        // Limpar o intervalo quando o componente for desmontado
        return () => (clearInterval(intervalId));
    }, []);

    async function onSubmit(data) {
        setCarregando(true);
        try {
            // para validar:
            const valid = await schema.isValid(data);

            // caso esteja validado
            if (valid) {
                const responseLogin = await api.post('/Login', data);
                console.log(responseLogin.data);
                sessionStorage.setItem("userName", responseLogin.data.userName)
                sessionStorage.setItem("token", responseLogin.data.token);
                sessionStorage.setItem("cpf", data.cpf);
                sessionStorage.setItem("emailLogin", responseLogin.data.userEmail);
                if (responseLogin.data.acessoPainel === true) {
                    navigate('/admin');
                } else if (responseLogin.data.contaAtiva == false) {
                    console.log(6);
                    alert("Sua conta não está mais ativa!\nEntre em contato para maiores informações");
                } else {
                    console.log(7);
                    const dados = await getDados(endpoint);
                    sessionStorage.setItem("celular", dados.celular);

                    sessionStorage.setItem("nome", dados.nome);
                    sessionStorage.setItem("celular", dados.celular);
                    dados.emailMutuario ? sessionStorage.setItem("emailMutuario", dados.emailMutuario) : sessionStorage.setItem("emailMutuario", "");
                    dados.emailCadastro ? sessionStorage.setItem("emailCadastro", dados.emailCadastro) : sessionStorage.setItem("emailCadastro", "");
                    // sessionStorage.setItem("emailMutuario", dados.emailMutuario);
                    // sessionStorage.setItem("emailCadastro", dados.emailCadastro);
                    sessionStorage.setItem("nacionalidade", dados.nacionalidade);
                    sessionStorage.setItem("dataDeNascimento", dados.dataDeNascimento);
                    dados.naturalidadeEstado ? sessionStorage.setItem("naturalidadeEstado", dados.naturalidadeEstado) : sessionStorage.setItem("naturalidadeEstado", "");
                    dados.naturalidadeCidade ? sessionStorage.setItem("naturalidadeCidade", dados.naturalidadeCidade) : sessionStorage.setItem("naturalidadeCidade", "");
                    sessionStorage.setItem("nome", dados.nome);
                    sessionStorage.setItem("rg", dados.rg);
                    sessionStorage.setItem("orgaoEmissor", dados.orgaoEmissor);
                    sessionStorage.setItem("sexoNascimento", dados.sexoNascimento);
                    sessionStorage.setItem("possuiDeficiencia", dados.possuiDeficiencia);
                    sessionStorage.setItem("tipoDeDeficiencia", dados.tipoDeDeficiencia);
                    sessionStorage.setItem("celularDeRecado", dados.celularDeRecado);
                    sessionStorage.setItem("contatoCelularRecado", dados.contatoCelularRecado);
                    sessionStorage.setItem("identidadeGenero", dados.identidadeGenero);
                    sessionStorage.setItem("nomeSocial", dados.nomeSocial);
                    sessionStorage.setItem("racaCor", dados.racaCor);
                    sessionStorage.setItem("possuiDoencaCronica", dados.possuiDoencaCronica);
                    sessionStorage.setItem("doencaCronicaDescricao", dados.doencaCronicaDescricao);
                    sessionStorage.setItem("funcionarioPublico", dados.funcionarioPublico);
                    sessionStorage.setItem("instituicaoPublica", dados.instituicaoPublica);
                    sessionStorage.setItem("votaEmPiracicaba", dados.votaEmPiracicaba);
                    sessionStorage.setItem("votaEmPiracicabaDesde", dados.votaEmPiracicabaDesde);
                    sessionStorage.setItem("cidadeDeVoto", dados.cidadeDeVoto);
                    sessionStorage.setItem("escolaridade", dados.escolaridade);
                    sessionStorage.setItem("estadoCivil", dados.estadoCivil);
                    sessionStorage.setItem("moraEmPiracicabaDesde", dados.moraEmPiracicabaDesde);

                    setCarregando(false);
                    navigate('/cadastroPessoal');

                }

            }


        } catch (err) {
            setErro(err.response.data.message);
        } finally {
            setCarregando(false);
        }

    }


    const titleHeader = useMediaQuery({
        query: '(min-width: 640px)'
    })

    //_5 Styles =========================================================================================

    return (
        <div className="BackgroundImg" style={{ textAlign: 'center' }}>
           <Header/>
            <Container sx={{ pt: '2vh', mb: 2 }}>

                <Paper
                    sx={{
                        p: 3,
                        maxWidth: 880,
                        margin: 'auto',
                        borderRadius: '16px'
                    }}
                >
                    <Paper
                        sx={{
                            p: 3,
                            margin: 'auto',
                            borderRadius: '8px',
                            boder: '1px solid #000',
                            backgroundColor: '#f5f5f5'
                        }}
                    >
                        <Box sx={{ mb: 3, position: 'relative' }}>
                            <p className={stylesText.subtitulo}>
                                Preencha as informações, caso ja tenha um cadastro.
                            </p>
                        </Box>

                        {/* _6 Formulário Login ===================================================================================== */}
                        <form onSubmitCapture={handleSubmit(onSubmit)}>
                            <Stack spacing={1} >

                                <Controller
                                    control={control}
                                    name="cpf"
                                    render={({ field }) => (
                                        <>
                                            <Box sx={{
                                                border: "1px solid #ccc",
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                m: 1,
                                                bgcolor: 'background.paper',
                                                borderRadius: 1,
                                            }}>
                                                <AccountCircleIcon sx={{
                                                    color: '#696969',
                                                    m: 1,
                                                    fontSize: '40px',
                                                    border: 'solix 1px #000'
                                                }} />

                                                {/* 
                                                Não utilizo o iMask, pois a porra do hook form conflita
                                                (propriedade {...field})
                                                */}
                                                <ReactInputMask
                                                    required
                                                    className={stylesInput.InputStyleLogin}
                                                    mask="999.999.999-99"
                                                    placeholder="CPF *"
                                                    {...field}  // importante

                                                />

                                                <p
                                                    style={{
                                                        color: 'red',
                                                        marginTop: '20px',
                                                        display: 'flex'
                                                    }}
                                                >
                                                    {errors.cpf?.message}
                                                </p>
                                            </Box>
                                        </>
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="password"
                                    render={({ field }) => (
                                        <>
                                            <Box sx={{
                                                border: "1px solid #ccc",
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                margin: "7px !important",
                                                bgcolor: 'background.paper',
                                                borderRadius: 1,
                                            }}>
                                                <KeyIcon sx={{
                                                    color: '#696969',
                                                    m: 1,
                                                    fontSize: '40px',
                                                    border: 'solix 1px #000'
                                                }} />
                                                <input
                                                    className={stylesInput.InputStyleLogin}
                                                    type={showPassword ? 'text' : 'password'}
                                                    placeholder="Senha *"
                                                    {...field} // importante
                                                />
                                                <a onClick={handlePasswordVisibility}>
                                                    <span className={showPassword ? stylesInput.icon : stylesInput.icon}>
                                                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                    </span>
                                                </a>
                                            </Box>
                                            <p style={{ color: 'red', display: 'flex', margin: '7px' }}>{errors.password?.message}</p>
                                        </>
                                    )}
                                />

                                {erro &&
                                    <Alert severity='error'>
                                        {erro}
                                    </Alert>
                                }

                                {erroCidadao &&
                                    <Alert severity='error'>
                                        {erroCidadao}
                                    </Alert>
                                }
                                <div>
                                    {contador > 0 && (
                                        <Alert severity='warning'>Aguarde {contador} segundos para tentar novamente</Alert>
                                    )}
                                </div>

                                <Stack direction='row'>
                                    <LoadingButton
                                        style={{ backgroundColor: '#3F51b5' }}
                                        loading={carregando}
                                        type="submit"
                                        fullWidth={true}
                                        variant='contained'
                                        disableElevation
                                    >
                                        Entrar
                                    </LoadingButton>
                                </Stack>

                                <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                                    <Link
                                        to="/"
                                        className={stylesText.linkCadastro}
                                        style={{ textDecoration: 'underline', marginTop: '16px' }}
                                    >
                                        Voltar para a tela de Cadastro
                                    </Link>

                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <p
                                            className={stylesText.perguntaCadastro}
                                        >
                                            Esqueceu sua senha?
                                        </p>

                                        <Link
                                            to="/restaurarConta"
                                            className={stylesText.linkCadastro}
                                            style={{ textDecoration: 'underline' }}
                                        >
                                            Clique aqui!
                                        </Link>
                                        <div
                                            style={{ color: "#9e9e9e", fontSize: "14px", marginTop: "14px" }}
                                        >Versão: {localStorage.getItem('AppVersion')}</div>
                                    </Box>
                                </Box>
                            </Stack>
                        </form>
                    </Paper>
                    <CodigoPenal />
                </Paper>
            </Container>
        </div >
    );
}